{ bool, func, instanceOf, string, object, oneOfType } = PropTypes
insertExtension = require 'components/document_sections/v2/editor_extensions/insert/insert'
InsertedGdtTable = require 'components/evidence_syntheses/inserted_gdt_table'
InsertModal = require 'components/etd/insert_modal'
{ getEpiditorContent, hasContentChanged, resetSelection } = require 'lib/epiditor_utils'
mediator = require 'mediator'
ReferencesInsertModal = require 'components/etd/references_insert_modal'
ReferenceCitationMixin = require 'components/mixins/reference_citation_mixin'
Translation = require 'components/mixins/translation'

{
  default: EpiditorComponent
  resetState: resetEditorState
  createControlExtension
  serializeState: serializeEditorState
} = Epiditor

editorUtils = Editor.EditorUtils
GdtEditorWithApply = Editor.EditorWithApply
GdtEditor = Editor.Editor

serializeEditorStateWithNewEditor = (state) ->
  _.extend newEditor: true, serializeEditorState state

EtdEditor = createReactClass
  displayName: 'EtdEditor'

  propTypes:
    additionalOptions: object
    attachments: instanceOf(Immutable.Map)
    cellId: string.isRequired
    className: string
    content: oneOfType [instanceOf(Immutable.Map), string]
    forceTableExpand: bool
    isConsensus: bool
    minimal: bool
    noAutoSave: bool
    noInsertOption: bool
    noReferencesInsert: bool
    onChange: func
    onFocus: func
    onSaveContent: func
    onSaveAttachment: func
    placeholder: string
    renderMode: string
    stickControlsTo: string
    withApplyCancelButtons: bool

  getDefaultProps: ->
    additionalOptions: null
    className: null
    forceTableExpand: false
    isConsensus: false
    minimal: false
    noAutoSave: false
    noInsertOption: false
    noReferencesInsert: false
    placeholder: null
    stickControlsTo: '#recommendations'
    withApplyCancelButtons: true
    onSaveAttachment: null
    onSaveContent: null

  mixins: [
    Translation('')
    ReferenceCitationMixin()
  ]

  getInitialState: ->
    showInsertModal: false
    showCancelApply: false
    isNewEditorEditing: false

  _isNewEditor: ->
    @props.content?.newEditor or mediator.project.get('useNewEditorInEtd')

  getContent: ->
    if @_isNewEditor()
      return serializeEditorStateWithNewEditor @newEditorView.state if @newEditorView
    else
      return @gdtEditor?.getEditorContent()

  resetContent: (content) ->
    if @_isNewEditor()
      return unless @newEditorView
      resetEditorState @newEditorView, getEpiditorContent content
    else
      @gdtEditor?.resetContent content

  focus: ->
    if @_isNewEditor()
      @newEditorView?.focus()
    else
      @gdtEditor?.focus()

  editorRef: (el) ->
    # when withApplyCancelButtons prop is true, EditorWIthApply is rendered which is a wrapper
    # around Editor, that is why need to get el.gdtEditor prop. Otherwise not wrapped Editor is
    # rendered, so it is safe to reference `el`
    @gdtEditor = if @props.withApplyCancelButtons then el?.gdtEditor else el

  _getInsertToggle: ->
    label: 'insert'
    onToggle: =>
      @gdtEditor.keepEditorActive()
      @setState showInsertModal: true

  _getCustomControls: ->
    referencesToggle = @getReferenceToggleSpec() unless @props.noReferencesInsert
    insertToggle = @_getInsertToggle() unless @props.noInsertOption
    _.compact [insertToggle, referencesToggle]

  _getCustomEntityRenderers: ->
    'GDT_TABLE': (Editor) =>
      component: InsertedGdtTable
      editable: false
      props:
        forceTableExpand: @props.forceTableExpand
        renderMode: @props.renderMode
        focusEditor: Editor.focus
        updateData: @updateEntityData
        isEditing: Editor.state.isEditing

  updateEntityData: (entityKey, newData, silent = false) ->
    editorUtils.updatedEntityData entityKey, newData
    if silent
      @saveContent()
    else
      mediator.dialogs.success 'Updated successfully'
      @gdtEditor.focus()

  closeInsertModal: ->
    @setState showInsertModal: false
    @gdtEditor.focus()

  onInsertModalSubmit: (insertData) ->
    { contentType, content } = insertData
    @closeInsertModal()

    if contentType is  'GDT_TABLE'
      gdtTableBlockSpec = type: 'GDT_TABLE', mutability: 'IMMUTABLE', data: content
      @gdtEditor.insertCustomBlock gdtTableBlockSpec
      content?.type is 'quality_indicators' and  @insertJustificationParagraph()
    else
      @gdtEditor.insertContent insertData

  insertJustificationParagraph: ->
    justificationData =
      contentType: 'HTML'
      content: "<br/><b>#{@i18n 'quality_indicators:table.justification'}:</b><br/>"
    _.defer =>
      @gdtEditor.insertContent justificationData

  onCancel: ->
    @gdtEditor.resetContent @props.content

  onApply: ->
    @saveContent()

  onBlur: (e) ->
    return if @props.noAutoSave
    # when onBlur is triggered by one of buttons from inserted table
    # then do not save content because it is being saved by updateEntityData method
    @saveContent() unless e.relatedTarget?.classList.contains 'inserted-table_button'

  saveContent: ->
    if @_isNewEditor()
      @_saveNewEditorContent()
    else
      @_saveOldEditorContent()

  _saveOldEditorContent: ->
    content = @gdtEditor.getEditorContent()
    options = isConsensus: @props.isConsensus
    @props.onSaveContent? { cellId: @props.cellId, content, options }

  saveAttachment: (file) ->
    attachmentName = "#{@props.cellId}/#{file.name.replace(/\s/g, '_')}"
    @props.onSaveAttachment? { attachmentName, file }
    attachmentName

  componentDidUpdate: (prevProps) ->
    return unless hasContentChanged prevProps.content, @props.content
    if @_isNewEditor()
      return unless @newEditorView
      resetEditorState @newEditorView, getEpiditorContent @props.content
    else
      @gdtEditor?.resetContent @props.content

  renderOldEditor: ->
    EditorComponent = if @props.withApplyCancelButtons then GdtEditorWithApply else GdtEditor

    <div className={@props.className || ""}>
      <EditorComponent
        attachments={@props.attachments}
        customControls={@_getCustomControls()}
        customEntityRenderers={@_getCustomEntityRenderers()}
        customDecorators={@getReferenceCitationDecorator()}
        customHandlers={handlePastedText: @handleReferencePaste}
        editorContent={@props.content}
        onChange={@props.onChange}
        onCancel={@onCancel}
        onApply={@onApply}
        onFocus={@props.onFocus}
        onBlur={@onBlur}
        placeholder={@props.placeholder}
        readOnly={not @props.editable}
        ref={@editorRef}
        stickControlsTo={@props.stickControlsTo}
        saveAttachment={@saveAttachment}
        showReferenceAttachments={@props.renderMode isnt 'printout'}
      />
      {if @state.showInsertModal
        <InsertModal
          additionalOptions={@props.additionalOptions}
          onClose={@closeInsertModal}
          onInsert={@onInsertModalSubmit}
        />
      }
      {if @state.showReferencesInsert
        <ReferencesInsertModal
          onInsert={@onInsertReferences}
          onClose={@toggleReferencesInsert}
        />
      }
    </div>

  handleNewEditorCancel: (view) -> =>
    resetEditorState view, getEpiditorContent @props.content
    @setState isNewEditorEditing: false

  handleNewEditorSave: (view) -> =>
    @_saveNewEditorContent view, @props.onSaveContent

  handleNewEditorBlur: (view) ->
    return if @props.noAutoSave
    handler = @props.onBlur ? @props.onSaveContent
    @_saveNewEditorContent view, handler

  _saveNewEditorContent: (view, handler) ->
    content = Immutable.fromJS serializeEditorStateWithNewEditor view.state
    options = isConsensus: @props.isConsensus
    resetSelection view
    @setState isNewEditorEditing: false
    handler? { cellId: @props.cellId, content, options }

  handleNewEditorChange: (view) ->
    @props.onChange? Immutable.fromJS serializeEditorStateWithNewEditor view.state

  handleNewEditorStartEdit: ->
    return if @props.renderMode is 'printout' or not @props.editable or @state.isNewEditorEditing
    @setState isNewEditorEditing: true

  getNewEditorExtensions: ->
    applyCancelControlsExt = createControlExtension 'applyCancelControlsExt', ({ view }) =>
      <div className="apply-cancel-editor-controls">
        <button className="cancel-btn" onClick={@handleNewEditorCancel(view)}>
          {@i18n '/actions.cancel'}
        </button>
        <button className="apply-btn" onClick={@handleNewEditorSave(view)}>
          {@i18n '/actions.save'}
        </button>
      </div>
    disabledInsertFeatures = _.compact [
      'references' if @props.noReferencesInsert
    ]
    insertExt = insertExtension @props.renderMode is 'printout',
      disabledFeatures: disabledInsertFeatures
    _.compact [
      applyCancelControlsExt if @props.withApplyCancelButtons
      insertExt
    ]

  newEditorContainerRef: (el) ->
    @newEditorContainer = el

  newEditorLoaded: (view) ->
    @newEditorView = view

  renderNewEditor: ->
    editMode = if @props.renderMode is 'printout' or not @props.editable or not @state.isNewEditorEditing
      'readonly'
    else
      'edit'

    <div className="etd-epiditor" ref={@newEditorContainerRef}>
      <EpiditorComponent
        extensions={@getNewEditorExtensions()}
        initialState={getEpiditorContent @props.content}
        mode={editMode}
        minimal={@props.minimal}
        onBlur={@handleNewEditorBlur}
        onChange={_.debounce @handleNewEditorChange, 500}
        onClick={@handleNewEditorStartEdit}
        onLoad={@newEditorLoaded}
        parentOverflowContainer={@newEditorContainer}
      />
    </div>

  render: ->
    if @_isNewEditor()
      @renderNewEditor()
    else
      @renderOldEditor()

module.exports = EtdEditor
